export default __webpack_public_path__ + "static/media/on-platform-pic.5f98e1ee.svg";